import { Spinner } from 'construct-ui';
import { messageComponent } from '../../../components/message/message.component';
import loginModel from '../../../models/login.model';
import teamApprovalModel from '../../../models/schedule/team-approval.modal';
import WorkTemplateTimePickerView from '../../schedule/work-templates/work-template-hour-min-picker.view';
import ViewBase from '../../view-base.view';
import TimePeriodView from './team-approval-time-period.view';

export default function TeamApprovalDetailsView() {

    ViewBase.call(this);
    let onSaved = () => { }
    let onClosed = () => { }
    let inputDataModel = {
        id: "",
        remarks: "", ddlStartTimeHour: { code: "00", name: "00" }, ddlStartTimeMin: { code: "00", name: "00" }, ddlEndTimeHour: { code: "00", name: "00" }, ddlEndTimeMin: { code: "00", name: "00" }
    };
    let itemDetails;
    let countryID = "";
    let isLoading = false;
    let isMsgOpen = false;
    let msgTitle = "";
    let showMsg = "";
    let userLanguageCode = "EN";


    let _dialogClosed = (e) => {
        isMsgOpen = false;
    }

    let _save = (status) => {
        isLoading = true;
        let sT = "";
        let eT = "";
        if (itemDetails.leaveDayOffType == "002" || itemDetails.leaveDayOffType == "003") {
            if (inputDataModel.ddlStartTimeHour.name != "" && inputDataModel.ddlEndTimeMin.name != "") {
                sT = inputDataModel.ddlStartTimeHour.name + ":" + inputDataModel.ddlEndTimeMin.name;
            }
            if (inputDataModel.ddlEndTimeHour.name != "" && inputDataModel.ddlEndTimeMin.name != "") {
                eT = inputDataModel.ddlEndTimeHour.name + ":" + inputDataModel.ddlEndTimeMin.name;
            }
        }

        teamApprovalModel.changeStatus(status, itemDetails, inputDataModel.remarks, sT, eT)
            .then((result) => {
                isLoading = false;
                onSaved(result);

            })
            .catch((error) => {
                isLoading = false;
                isMsgOpen = true;
                showMsg = error.response[0].transStatus;
                msgTitle = this.getText(error.response[0].code);
            });
    }
    let _cancel = () => {
        onClosed();
    }
    return {
        oninit: function (vnode) {
            countryID = loginModel.credentials.country;
            userLanguageCode = loginModel.credentials.language;
            if (vnode.attrs.onSaved) {
                onSaved = vnode.attrs.onSaved;
            }
            if (vnode.attrs.onClosed) {
                onClosed = vnode.attrs.onClosed;
            }

        },
        oncreate: function (vnode) {

        },
        onupdate: function (vnode) {
            if (countryID != loginModel.credentials.country) {
                countryID = loginModel.credentials.country;
                userLanguageCode = loginModel.credentials.language;

            }
        },
        view: (vnode) => {
            inputDataModel.id = vnode.attrs.item.scheduleApprovalID;
            itemDetails = vnode.attrs.item;
            return [
                m(Spinner, {
                    active: isLoading,
                    background: true,
                    fill: true,
                    size: 'xl',
                }),
                m('.card.card-no-border',
                    m('.card-body',
                        m('.row p-4',

                            m('.col-md-12.row',
                                m('.col-md-3.right', m('img.userImg-circle-lg[src=' + itemDetails.photoString + ']')), m('.col-md-9', itemDetails.userName)),
                            m('hr'),
                            m('.col-md-12',
                                m('.form-group row',
                                    m('label.col-md-3.col-form-label.right', this.getText("LT00000144", "Site Name")), m('label.col-md-8.col-form-label', itemDetails.siteName)),
                                m('.form-group row',
                                    m('label.col-md-3.col-form-label.right', this.getText("LT00000132", "Date")), m('label.col-md-8.col-form-label', itemDetails.scheduleDateFormat)),
                                m('.form-group row',
                                    m('label.col-md-3.col-form-label.right', this.getText("LT00000149", "Work Type")), m('label.col-md-8.col-form-label',
                                        itemDetails.workType == "001" && m('span.work-type-work', m('i.bi.bi-circle-fill'), itemDetails.scheduleNameDisplay),
                                        itemDetails.workType == "002" && m('span.work-type-leave', m('i.bi.bi-circle-fill'), itemDetails.scheduleNameDisplay),
                                        itemDetails.workType == "003" && m('span.work-type-day-off', m('i.bi.bi-circle-fill'), itemDetails.scheduleNameDisplay),
                                        itemDetails.workType == "004" && m('span.work-type-training', m('i.bi.bi-circle-fill'), itemDetails.scheduleNameDisplay),
                                        itemDetails.workType == "005" && m('span.work-type-road-show', m('i.bi.bi-circle-fill'), itemDetails.scheduleNameDisplay),
                                        itemDetails.workType == "006" && m('span.work-type-others', m('i.bi.bi-circle-fill'), itemDetails.scheduleNameDisplay),
                                        itemDetails.workType == "007" && m('span.work-type-special-task', m('i.bi.bi-circle-fill'), itemDetails.scheduleNameDisplay)
                                    )),
                                !(itemDetails.leaveDayOffType == "002" || itemDetails.leaveDayOffType == "003") && m('.form-group row',
                                    m('label.col-md-3.col-form-label.right', this.getText("LT00000182", "Working Hours")), m('label.col-md-8.col-form-label', m(TimePeriodView, { data: itemDetails }))),

                                (itemDetails.leaveDayOffType == "002" || itemDetails.leaveDayOffType == "003") && m('.form-group row',
                                    m('label.col-md-3.col-form-label.right', this.getText("LT00000182", "Working Hours")),
                                    m('.col-md-9',
                                        m('.row',
                                            m('.col',
                                                m(WorkTemplateTimePickerView, {
                                                    pickerType: "hour", onChanged: (selectedItem) => {
                                                        inputDataModel.ddlStartTimeHour = selectedItem;
                                                    }, disabled: itemDetails.scheduleApprovalType != "001", selectedItem: inputDataModel.ddlStartTimeHour
                                                })
                                            ),
                                            m('.col-md-1.center', { "style": "width:3%" }, m('label.font-size-26', ":")),
                                            m('.col',
                                                m(WorkTemplateTimePickerView, {
                                                    pickerType: "min", onChanged: (selectedItem) => {
                                                        inputDataModel.ddlStartTimeMin = selectedItem;
                                                    }, disabled: itemDetails.scheduleApprovalType != "001", selectedItem: inputDataModel.ddlStartTimeMin
                                                })
                                            ),
                                            m('.col-md-1.center', { "style": "width:3%" }, m('label.font-size-26', "~")),
                                            m('.col',
                                                m(WorkTemplateTimePickerView, {
                                                    pickerType: "hour", onChanged: (selectedItem) => {
                                                        inputDataModel.ddlEndTimeHour = selectedItem;
                                                    }, disabled: itemDetails.scheduleApprovalType != "001", selectedItem: inputDataModel.ddlEndTimeHour
                                                })
                                            ),
                                            m('.col-md-1.center', { "style": "width:3%" }, m('label.font-size-26', ":")),
                                            m('.col',
                                                m(WorkTemplateTimePickerView, {
                                                    pickerType: "min", onChanged: (selectedItem) => {
                                                        inputDataModel.ddlEndTimeMin = selectedItem;
                                                    }, disabled: itemDetails.scheduleApprovalType != "001", selectedItem: inputDataModel.ddlEndTimeMin
                                                })
                                            )),
                                    )),
                                m('.form-group row',
                                    m('label.col-md-3.col-form-label.right', this.getText("LT00000152", "Remarks")), m('label.col-md-9.col-form-label', m('input[type="text"][readonly].form-control.form-control-bg[value="' + itemDetails.remarks + '"]'))),
                                itemDetails.scheduleApprovalType == "001" && m('.form-group row',
                                    m('label.col-md-3.col-form-label.right', this.getText("LT00000183", "Supervisor Remarks")), m('.col-md-9', m('textarea.form-control.form-control-bg', {
                                        onchange: (e) => {
                                            inputDataModel.remarks = e.target.value;
                                        }
                                    }))),


                            ),

                        ),
                    ),
                    m('.card-footer',
                        m('.col-md-12 .gap-2 .d-flex .justify-content-end',
                            itemDetails.scheduleApprovalType == "001" && m(
                                "button.btn.btn-primary[type='button']", { onclick: () => { _save('A') } },
                                this.getText("LT00000185", "Approve")
                            ),
                            itemDetails.scheduleApprovalType == "001" && m(
                                "button.btn.btn-danger[type='button']", { onclick: () => { _save('R') } },
                                this.getText("LT00000184", "Reject")
                            ),
                            // m(
                            //     "button.btn.btn-white[type='button']", { onclick: _cancel },
                            //     this.getText("LT00000021", "Close")
                            // )
                        ))),
                m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed }),
                this.getBaseViews()
            ]
        }
    }
}
